// @core/api/endpoints/task/get_task_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskTypeDefinitionResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task type
 * Returns a task type definition by ID or slug.
 */
export async function GetTaskType(
  type_id: string,
  options?: RequestOptions
): Promise<TaskTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<TaskTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
